import "../fonts/delicious-handrawn/styles.scss"
import "../fonts/noto-serif/styles.scss"
import "../fonts/roboto/styles.scss"
import "../fonts/ubuntu/styles.scss"

export type Font = {
    id: string
    name: string
}

export const fontList: Font[] = [
    { id: 'ubuntu', name: 'Ubuntu' }, 
    { id: 'roboto', name: 'Roboto' }, 
    { id: 'noto-serif', name: 'Noto Serif' }, 
    { id: 'delicious-handrawn', name: 'Delicious Handrawn' }
]

export enum Format {
    H1 = "H1",
    H2 = "H2",
    H3 = "H3",
    H4 = "H4",
    H5 = "H5",
    H6 = "H6",
    Normal = "Normal"
}

export function getFormatLabel(f : Format) {
    switch (f) {
        case Format.H1:
            return "Capçalera 1";
        case Format.H2:
            return "Capçalera 2";
        case Format.H3:
            return "Capçalera 3";
        case Format.H4:
            return "Capçalera 4";
        case Format.H5:
            return "Capçalera 5";
        case Format.H6:
            return "Capçalera 6";
        case Format.Normal:
            return "Normal";
    }
}

export function getFontSize(value: Format) {
    switch (value) {
        case Format.H1:
            return "1.2em";
        case Format.H2:
            return "1.1em";
        case Format.H3:
            return "1.0em";
        case Format.H4:
            return "0.9em";
        case Format.H5:
            return "0.8em";
        case Format.H6:
            return "0.7em";
        case Format.Normal:
            return "1em";
    }
}

export function getLevel(value: Format) {
    switch (value) {
        case Format.H1:
            return 1;
        case Format.H2:
            return 2;
        case Format.H3:
            return 3;
        case Format.H4:
            return 4;
        case Format.H5:
            return 5;
        case Format.H6:
            return 6;
        default:
            return 1;
    }
}

export function getHeading(level: number) {
    switch (level) {
        case 1:
            return Format.H1;
        case 2:
            return Format.H2;
        case 3:
            return Format.H3;
        case 4:
            return Format.H4;
        case 5:
            return Format.H5;
        case 6:
            return Format.H6;
        default:
            return Format.H1;
    }
}

export const format = [Format.H1, Format.H2, Format.H3, Format.Normal]